import { createFileRoute, redirect } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { authClient } from '@/lib/auth-client';
import { api } from '@/lib/api-client';
import { AuditTimeline } from '@/components/audit/audit-timeline';

export const Route = createFileRoute('/_authenticated/audit')({
  beforeLoad: async () => {
    const session = await authClient.getSession();
    if (!session.data) throw redirect({ to: '/' });

    try {
      const perms = await api.get<{ data: { role: string } }>('/permissions/me');
      const role = perms.data?.role;
      // Only OWNER and ADMIN can access audit logs
      if (role !== 'OWNER' && role !== 'ADMIN') {
        throw redirect({ to: '/dashboard' });
      }
    } catch (e) {
      if (e && typeof e === 'object' && 'to' in e) throw e;
      throw redirect({ to: '/dashboard' });
    }
  },
  component: AuditPage,
});

function AuditPage() {
  const { t } = useTranslation();

  return (
    <div className="mx-auto max-w-3xl space-y-6">
      <h1 className="text-2xl font-bold tracking-tight">{t('audit.title')}</h1>
      <AuditTimeline />
    </div>
  );
}
